import { useMemo } from "react";

import range from "ramda/src/range";
import inc from "ramda/src/inc";
import dec from "ramda/src/dec";
import { normalize } from "../helpers/normalize";

export const usePaginationHandler = (
  rows: any[],
  page: number,
  perPage: number
) => {
  const pages = useMemo(() => {
    const itemsPerPage = inc(Math.ceil(rows.length / perPage));
    const rangeTo = itemsPerPage <= 1 ? 2 : itemsPerPage;
    return range(1, rangeTo);
  }, [normalize(rows), perPage]);

  const selectedRows = useMemo(() => {
    const from = dec(page) * perPage;
    const to = dec(page) * perPage + perPage;
    
    return rows.slice(from, to);
  }, [page, perPage, normalize(rows)]);

  return {
    selectedRows,
    pages,
  };
};
